import {EventEmitter, Injectable} from '@angular/core';
import {Bundesland, BundesLandName} from '../../model/component/bundesland';

@Injectable({
  providedIn: 'root'
})
export class BundeslandFilterService {

  // TODO: Versuchen codes wie BW, BY, ... zum filtern zu verwenden, anstatt die Namen; das erspart einem
  //  Sonderfälle wie 'Freie Hansestadt Bremen', 'Hansestadt Bremen', 'Bremen',...
  private FILTER_ITEMS = ['Deutschland', BundesLandName.BW, BundesLandName.BB, BundesLandName.BY, BundesLandName.BE, BundesLandName.HB,
    BundesLandName.HH, BundesLandName.HE, BundesLandName.MV, BundesLandName.NI, BundesLandName.NW, BundesLandName.RP,
    BundesLandName.SL, BundesLandName.SN, BundesLandName.ST, BundesLandName.SH, BundesLandName.TH
  ];

  filter: Bundesland[] = this.createFilter();

  onFilterUpdated: EventEmitter<Array<Bundesland>> = new EventEmitter<Array<Bundesland>>();

  constructor() {
    this.getFromSession();
  }

  public createFilter() {
    let filterItems = [];
    for (const name of this.FILTER_ITEMS) {
      if (name === BundesLandName.HB) {
        filterItems.push(new Bundesland(name, true));
      } else {
        filterItems.push(new Bundesland(name, false));
      }
    }
    return filterItems;
  }

  public updateFilter() {
    this.onFilterUpdated.emit(this.getSelectedBundesLaender());
    this.updateSession();
  }

  private updateSession() {
    localStorage.setItem('bundeslaender', JSON.stringify(this.filter));
  }

  private getFromSession() {
    let bundeslaender = localStorage.getItem('bundeslaender');
    if (bundeslaender !== undefined && bundeslaender !== null) {
      this.filter = JSON.parse(bundeslaender);
    }
  }

  public remove(bundesland) {
    this.filter.splice(bundesland, 1);
  }

  public get selectedBundesLand() {
    return this.filter.find(land => land.isSelected);
  }

  public getSelectedBundesLaender() {
    return this.filter.filter(land => land.isSelected);
  }

  public getSelectedBundesLaenderNamen(): string[] {
    return this.getSelectedBundesLaender().map(value => value.name);
  }

  public getSelectedBundeslaenderNamesWithSimpleNameForBremen(): string[] {
    return this.getSelectedBundesLaender().map(value => value.name === BundesLandName.HB ? 'Bremen' : value.name);
  }

  public deselectAll() {
    this.filter.forEach(land => land.isSelected = false);
  }

  public hasDeutschlandFilterActive(): boolean {
    return this.hasBundeslandFilterActive('Deutschland');
  }

  private hasBundeslandFilterActive(name: string): boolean {
    return this.filter.find(filterElement => filterElement.name === name)?.isSelected;
  }

}
